import * as React from 'react';

import './ECheckPaymentDetailsRow.scss';
import LocaleFormating from 'src/translation/localeFormating';

interface IECheckPaymentDetailsRowProps {
  invoice: any;
  customerCode: string;
}

class ECheckPaymentDetailsRow extends React.Component<
  IECheckPaymentDetailsRowProps,
  any
> {
  public render() {
    return (
      <div className="rp-echeck-payment-details-row">
        <div className="rp-echeck-p-details-item col-2">
          <span>{this.props.invoice.invoiceNumber}</span>
        </div>
        <div className="rp-echeck-p-details-item col-2">
          <span>
            {LocaleFormating.formatDate(
              this.props.invoice.invoiceDate,
              'short'
            )}
          </span>
        </div>
        <div className="rp-echeck-p-details-item col-2">
          <span>{this.props.customerCode}</span>
        </div>
        <div className="rp-echeck-p-details-item col-2">
          <span>
            {LocaleFormating.formatCurrency(this.props.invoice.totalAmount)}
          </span>
        </div>
        <div className="rp-echeck-p-details-item col-2">
          <span>
            {LocaleFormating.formatCurrency(this.props.invoice.paymentAmount)}
          </span>
        </div>
        <div className="rp-echeck-p-details-item col-2 rp-credits-p-details-italic">
          <span>{this.props.invoice.reason}</span>
        </div>
      </div>
    );
  }
}

export default ECheckPaymentDetailsRow;
